// Import controller interfaces
import { IMinCostPerSquareFootLookupController } from '../Interfaces/ControllerInterfacesBarrel';
// Import api base controller
import ApiController from './ApiController';
// Import api models
import {
    MinCostPerSquareFootLookup,
    MinCostPerSquareFootWithId,
    ErrorMessage,
} from '@app/models/api';

export default class ProductionMinCostPerSquareFootLookupController extends ApiController implements IMinCostPerSquareFootLookupController {
    private readonly controllerUrl: string = 'v2/admin/MinCostPerSquareFootLookup';

    public constructor() {
        super();
    }

    public async getAllMinCostPerSquareFootLookup(
        minCostPerSquareFootLookup: MinCostPerSquareFootLookup
    ): Promise<MinCostPerSquareFootWithId[]> {
        const url: string = `${this.controllerUrl}`;
        const data = minCostPerSquareFootLookup;

        try {
            const response: Response = await super.makePostCall(url, data);
            return await response.json();
        }
        catch (error) {
            if (ErrorMessage.isErrorMessage(error)) {
                error.message = 'ERROR: could not retrieve the Min Cost Per Square Foot Lookup.';
            }
            throw error;
        }
    }

}